import axios from "axios";
import { getToken } from "../Auth";
// Page-loading GETs use getWithRetry: it waits for the sleeping backend instead of failing
import { getWithRetry } from "./retry";

//  const DEALS_API_BASE_URL="http://localhost:8080/api";
//  const USER_API_BASE_URL="http://localhost:8080/"
const DEALS_API_BASE_URL="https://dinodeal-backend-1.onrender.com/api"
//   const DEALS_API_BASE_URL="https://dinodealz-backend-bcb469ab952a.herokuapp.com/api"
//  const DEALS_API_BASE_URL="http://localhost:8080/api";
//  const USER_API_BASE_URL="http://localhost:8080/"
const USER_API_BASE_URL="https://dinodeal-backend-1.onrender.com/";
//    const USER_API_BASE_URL="https://dinodealz-backend-bcb469ab952a.herokuapp.com/"
// const DEALS_API_BASE_URL="http://localhost:8080/image";
class UserService{
    getURl(){
        return DEALS_API_BASE_URL;
    }
    getStoreDeals(store){
        return getWithRetry(DEALS_API_BASE_URL+"/deals_by_store/"+store);
    }
    getcategoryDeals(category){
        return getWithRetry(DEALS_API_BASE_URL+"/deals_by_category/"+category);
    }
    getCategory(){
        return getWithRetry(DEALS_API_BASE_URL+"/category/")
    }
    getSearchDeals(searchstring){
        return getWithRetry(DEALS_API_BASE_URL+"/search/"+searchstring)
    }

    getStore(){
        return getWithRetry(DEALS_API_BASE_URL+"/store/")
    }
    // getDeals(){
    //     return axios.get(DEALS_API_BASE_URL+"/deals");
    // }
    getDeals(pagenumber,pagesize){
        return getWithRetry(DEALS_API_BASE_URL+"/deals/"+pagenumber+"/"+pagesize);
    }
    postContactUs(contactDetails){
        return axios.post(USER_API_BASE_URL+"api/contactus/add",contactDetails)
    }

    postSignUp(signupDetails){
        // return axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/signup/add`,signupDetails)
        return axios.post("http://localhost:8080/api/signup/add",signupDetails)
    
        // return axios.post("https://dinodeal-backend-1.onrender.com/api/signup/add",signupDetails)
    }
    postlogin(loginDetails){
        return axios.post(USER_API_BASE_URL+"auth/login",loginDetails)
    }

    postregistration(registrationdata){
       return axios.post(USER_API_BASE_URL+"registration/", registrationdata,{
         headers: { Accept: 'application/json',
         Authorization: `Bearer ${getToken()}` }})

    }

    // new: update one sub-deal (formData can include a new "imagefile"; without it the old photo stays)
    updateSubDeal(subdealId, formData){
       return axios.put(DEALS_API_BASE_URL+"/subdeal/"+subdealId, formData,{
         headers: { Accept: 'application/json',
         'Content-Type': 'multipart/form-data',
         Authorization: `Bearer ${getToken()}` }})
    }

    // new: add a sub-deal to an existing deal (same backend endpoint the Add Deals page uses)
    addSubDeal(dealId, formData){
       return axios.post(DEALS_API_BASE_URL+"/subdeal/"+dealId, formData,{
         headers: { Accept: 'application/json',
         'Content-Type': 'multipart/form-data',
         Authorization: `Bearer ${getToken()}` }})
    }

    // new: delete one sub-deal
    deleteSubDeal(subdealId){
       return axios.delete(DEALS_API_BASE_URL+"/subdeal/"+subdealId,{
         headers: { Authorization: `Bearer ${getToken()}` }})
    }

    // new: ADMIN sets a new password for a user who forgot theirs
    resetUserPassword(email, newPassword){
       return axios.put(USER_API_BASE_URL+"registration/password", { email, newPassword },{
         headers: { Accept: 'application/json',
         Authorization: `Bearer ${getToken()}` }})
    }
  

    //change in adddeal.js and editdeals.js
     privateAxios=axios.create({
        baseURL:DEALS_API_BASE_URL
    })

    createDeals(deal){
        console.log("i am in create deal")
        this.privateAxios.interceptors.request.use(config=>{
            const token=getToken()
            console.log(token)
            if(token)
            {
                config.headers.common.Authorization=`Bearer {$token}`
                return;
            }
        },error=>Promise.reject(error))
        // return axios.post(DEALS_API_BASE_URL+"/upload",deal);
    }

    getDealDetail(id){
        // console.log("i am in getdealdetail")
        return getWithRetry(DEALS_API_BASE_URL+"/dealdetails/"+id)
    }

    
    // createUser(user){
    //     return axios.post(USER_API_BASE_URL+"registration",user)
    // }
    
}

const userService = new UserService();
export default userService;
